export default __webpack_public_path__ + "static/media/Globe.6eba9819.svg";